/**
 * Баннер cookie для лендингов (аналог CookiePolicy.vue + vue-cookie-accept-decline).
 * Ключ хранилища тот же, чтобы согласие совпадало с Vue-приложением.
 */
const STORAGE_KEY = 'vue-cookie-accept-decline-cookie-accept';
const VERBOX_WAIT_MS = 20000;
const VERBOX_POLL_MS = 250;
const HIDE_ANIMATION_MS = 200;

let supportsLocalStorage = true;
let verboxWaitTimer = null;

function checkLocalStorage() {
    try {
        const test = '__vue-cookie-accept-decline-check-localStorage';
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        supportsLocalStorage = true;
    } catch (e) {
        supportsLocalStorage = false;
    }
}

function getCookie(name) {
    const escaped = name.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '(?:=([^;]*))?(?:;|$)'));

    if (!match) {
        return null;
    }

    try {
        return decodeURIComponent(match[1] || '');
    } catch (e) {
        return match[1] || '';
    }
}

function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/';
}

function getCookieStatus() {
    if (supportsLocalStorage) {
        return localStorage.getItem(STORAGE_KEY);
    }

    return getCookie(STORAGE_KEY);
}

function setCookieStatus(type) {
    if (supportsLocalStorage) {
        localStorage.setItem(STORAGE_KEY, type);
        return;
    }

    setCookie(STORAGE_KEY, type);
}

function callVerbox(method) {
    if (typeof Verbox === 'undefined') {
        return false;
    }

    Verbox(method);
    return true;
}

function waitVerbox(method) {
    if (callVerbox(method)) {
        return;
    }

    const started = Date.now();
    clearInterval(verboxWaitTimer);
    verboxWaitTimer = setInterval(function () {
        if (callVerbox(method) || Date.now() - started > VERBOX_WAIT_MS) {
            clearInterval(verboxWaitTimer);
            verboxWaitTimer = null;
        }
    }, VERBOX_POLL_MS);
}

function hideBar(container, bar) {
    bar.classList.remove('is-visible');
    bar.classList.add('is-hiding');

    window.setTimeout(function () {
        container.hidden = true;
        bar.classList.remove('is-hiding');
    }, HIDE_ANIMATION_MS);
}

function initCookiePolicy() {
    const container = document.getElementById('cookie-policy');
    const bar = document.getElementById('cookie-accept');
    const acceptButton = container ? container.querySelector('[data-cookie-accept]') : null;

    if (!container || !bar || !acceptButton) {
        return;
    }

    checkLocalStorage();

    const visitedType = getCookieStatus();

    if (!visitedType) {
        container.hidden = false;
        window.requestAnimationFrame(function () {
            bar.classList.add('is-visible');
        });
    }

    if (visitedType !== 'accept') {
        waitVerbox('hideTrigger');
    }

    acceptButton.addEventListener('click', function () {
        setCookieStatus('accept');
        hideBar(container, bar);
        clearInterval(verboxWaitTimer);
        verboxWaitTimer = null;
        waitVerbox('showTrigger');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookiePolicy);
} else {
    initCookiePolicy();
}
